module.exports = __webpack_public_path__ + "static/media/Brandon.a475ae34.jpg";